import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
// import AutoSuggestionsdata from '../Movie/Autosuggestionsdata'
// import Dragdrop from '../Movie/Dragdrop'
// import GetFormattedData from '../Movie/GetFormattedData'
import AwsConfig from '../../Config/AwsConfig'
// import Dragdrop from './TfidbDragandDrop'
import AutoSuggestions from '../../Services/Queries/AutoSuggestions'
import TfidbPersonMovieDragandDrop from './TfidbPersonMovieDragandDrop'
import FormattedDate from '../Movie/getFormattedDate'

const TfidbPersonMovie = props => {
  //   const [ProductionCompneyNames, setpersonInputnames] = useState([])
  const [personInputname, setpersonInputname] = useState('')
  //   const [personInputnameTelugu, setpersonInputnameTelugu] = useState('')
  // const [searchBoolean, setsearchBoolean] = useState(true)
  const [autoSuggestions, setAutoSuggestions] = useState([])
  const [editMode, seteditMode] = useState(true)

  const { inputData, sendinputdata, name, inputField1, disableInput, setValueChanged } = props

  const sendEditmode = data => {
    seteditMode(data)
  }

  const handlepersonInputnamechange = async value => {
    setpersonInputname(value)
    if (value.length <= 3) {
      setAutoSuggestions([])
    }

    if (value.length >= 3) {
      try {
        const input = {
          search: value,
          type: 'all',
          limit: 100,
          from: 0,
        }
        const movieData = await AutoSuggestions(input)
        setAutoSuggestions(movieData.movieHits)
      } catch (err) {
        console.warn(err)
        setAutoSuggestions([])
      }
    }
  }

  const PersonNameSelection = index => {
    setValueChanged(true)
    const inputDataTemp = { ...inputData }
    const selectedPerson = autoSuggestions[index]
    selectedPerson.isAnonymous = false
    const inputDataEnglishTemp = [...inputData[inputField1], selectedPerson]
    inputDataTemp[inputField1] = inputDataEnglishTemp

    sendinputdata(inputDataTemp)
    setpersonInputname('')
    setAutoSuggestions([])
  }

  const finalfilteredPersonNames = Array.isArray(autoSuggestions) ? [...autoSuggestions] : []
  //   if (personInputname.length >= 3) {
  //     finalfilteredPersonNames.unshift({ name_En: `Create ${personInputname}` })
  //   }

  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <label>{`${name}_En`}:</label>
            {
              <div>
                <TfidbPersonMovieDragandDrop
                  name={name}
                  inputData={inputData}
                  truevalue={props.truevalue}
                  sendtruevalue={props.sendtruevalue}
                  display={inputData[inputField1]}
                  senddata={sendinputdata}
                  editmode={editMode}
                  editpersonmode={editMode}
                  sendPersonEditmode={sendEditmode}
                  modeUrl={true}
                  indication={true}
                  inputField1={inputField1}
                  setValueChanged={setValueChanged}
                />
              </div>
            }
            {!(
              (name === 'firstMovie' || name === 'firstSuccessfulMovie') &&
              inputData[inputField1].length === 1
            ) && (
              <input
                type={'text'}
                className='form-control'
                onChange={e => handlepersonInputnamechange(e.target.value)}
                value={personInputname}
                disabled={disableInput === true}
              />
            )}

            {finalfilteredPersonNames.length >= 1 && (
              <div
                className='searchfield'
                style={{
                  width: '200%',
                  position: 'relative',
                  zIndex: '1',
                }}
              >
                {finalfilteredPersonNames.map((crewName, crewIndex) => {
                  let { posterURL } = crewName
                  if (posterURL === 'none' || posterURL === '') {
                    posterURL =
                      AwsConfig.movieCdnUrl + AwsConfig.avatharPath + AwsConfig.personStaticImage
                  } else if (posterURL && !posterURL.includes(AwsConfig.movieCdnUrl)) {
                    posterURL = AwsConfig.movieCdnUrl + posterURL
                  }

                  return (
                    <div
                      key={crewIndex}
                      onClick={() => PersonNameSelection(crewIndex)}
                      style={{
                        width: '100%',
                        marginRight: '10px',
                        boxSizing: 'unset',
                        height: '3.5rem',
                      }}
                    >
                      <ul className='list-group list-group-flush' style={{ height: '3.5rem' }}>
                        <li
                          className='list-group-item'
                          style={{ marginRight: 'auto', width: '100%', height: '3.5rem' }}
                        >
                          <div className='media d-flex justify-content-center align-items-center'>
                            {
                              <img
                                style={{ width: '2rem', height: '2rem', marginRight: 'auto' }}
                                className='mr-3 align-self-center'
                                src={posterURL}
                              />
                            }
                            <div
                              className='media-body align-self-center'
                              style={{ display: 'flex', flexWrap: 'wrap', fontSize: '10px' }}
                            >
                              {
                                <>
                                  <span>
                                    <b>
                                      Movie Name:
                                      <span style={{ fontSize: '10px' }}>
                                        {crewName.title_En}
                                        {crewName.movieReleasedDate
                                          ? `(${FormattedDate(crewName.movieReleasedDate)})`
                                          : ''}
                                      </span>
                                    </b>
                                    {/* {crewName.roles?.length > 0
                                        ? `(${[...new Set(crewName.roles)]
                                            .slice(0, Math.min(crewName.roles.length, 5))
                                            .toString()})`
                                        : ''} */}
                                  </span>
                                  <br />
                                  {/* <span>{crewName.personWikiURL}</span> */}
                                </>
                              }
                            </div>
                          </div>
                        </li>
                        <hr style={{ background: 'black', color: 'black' }} />
                      </ul>
                    </div>
                  )
                })}
              </div>
            )}
            {/* {!searchBoolean && (
              <input
                className='form-control'
                value={personInputname}
                style={{ width: '100%' }}
                onChange={event => PersonNameEnglish(event)}
                disabled={disableInput === true}
              />
            )} */}
          </div>
        </Col>
        {inputData[inputField1] && inputData[inputField1].length >= 1 && (
          <Col md={6} xs={12}>
            <div>
              <label>{`${name}_Te`}:</label>
              <div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid lightgray',
                    borderRadius: '1rem',
                  }}
                  className='rounded'
                >
                  {inputData[inputField1].map((e, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: '10px',
                        border: '1px solid black',
                        padding: '3px',
                        borderRadius: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        minWidth: '100px',
                        minHeight: '45px',
                        width: 'fit-content',
                        // justifyContent: 'center',
                      }}
                    >
                      <div style={{ marginRight: '10px' }}>
                        {e.isAnonymous ? (
                          ''
                        ) : (
                          <img
                            style={{
                              width: '2rem',
                              height: '2rem',
                              borderRadius: '50%',
                              marginRight: '15px',
                            }}
                            src={AwsConfig.movieCdnUrl + e.posterURL}
                            // alt={inputData[inputFieldEnglish][index].name_En}
                          />
                        )}
                        {/* {e.isAnonymous ? (
                          <span
                            style={{
                              color: 'white',
                              backgroundColor: 'gray',
                              fontSize: '8px',
                              position: 'absolute',
                              top: '0px',
                              right: '10px',
                            }}
                          >
                            Anonymous
                          </span>
                        ) : (
                          ''
                        )} */}
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <span>{e.title_Te}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* input for telugu when manually entered */}
              {/* {!searchBoolean && (
                <input
                  type='text'
                  className='form-control'
                  value={personInputnameTelugu}
                  style={{ width: '100%' }}
                  disabled={disableInput === true}
                  onChange={event => PersonNameTelugu(event)}
                />
              )}
            </div> */}
              {/* button for sending manually added english and telugu names to parent */}
              {/* {!searchBoolean && (
              <button
                style={{ float: 'right' }}
                disabled={!(personInputname.length >= 1) && disableInput === true}
                type='button'
                onClick={() => Submitperson()}
                className='btn btn-primary'
              >
                ok
              </button>
            )} */}
              {/* {(!searchBoolean ||
          (inputData[inputField1] && inputData[inputField1].length >= 1)) && (
          <Col md={6} xs={12}>
            <div>
              <label>{`${name}_Te`}:</label>
              <div>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    border: '1px solid lightgray',
                    borderRadius: '1rem',
                  }}
                  className='rounded'
                >
                  {inputData[inputField1].map((e, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: '10px',
                        border: '1px solid black',
                        padding: '3px',
                        borderRadius: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        minWidth: '100px',
                        minHeight: '45px',
                        // justifyContent: 'center',
                      }}
                    >
                      <div style={{ marginRight: '10px' }}>
                        {e.isAnonymous ? (
                          ''
                        ) : (
                          <img
                            style={{
                              width: '2rem',
                              height: '2rem',
                              borderRadius: '50%',
                              marginRight: '15px',
                            }}
                            src={
                              AwsConfig.movieCdnUrl + e.posterURL
                            }
                            // alt={inputData[inputFieldEnglish][index].name_En}
                          />
                        )}
                        {e.isAnonymous ? (
                          <span
                            style={{
                              color: 'white',
                              backgroundColor: 'gray',
                              fontSize: '8px',
                              position: 'absolute',
                              top: '0px',
                              right: '10px',
                            }}
                          >
                            Anonymous
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <span>{e}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {!searchBoolean && (
                <input
                  type='text'
                //   value={crewNameTelugu}
                  className='form-control'
                //   onChange={event => crewTelugu(event)}
                />
              )}
            </div>
            {!searchBoolean && (
              <button
                style={{ float: 'right' }}
                // disabled={!crewOkButtonDisable()}
                type='button'
                // onClick={() => SubmitCrewperson()}
                className='btn btn-primary'
              >
                ok
              </button>
            )}
          </Col>
        )} */}
            </div>
          </Col>
        )}
      </Row>
    </div>
  )
}

export default TfidbPersonMovie
